import { Base } from "./base";

export class Auth extends Base {
  /**
   * @description Login API function
   * @param {string} email
   * @param {string} password
   * @returns {Promise<Response>}
   */
  login(email, password, chosen_company,token) {
    const url = this._getFullURL("/auth/login");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload: { email, password, chosen_company,token },
        method: "POST",
      })
    );
  }
  loginByPass(token) {
    const url = this._getFullURL("/auth/login-bypass");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload: { login_token: token },
        method: "POST",
      })
    );
  }
  self() {
    const url = this._getFullURL("/auth/self");
    return fetch(
      url,
      this._generateRequestBody({
        method: "GET",
      })
    );
  }

  changePassword(old_password, confirmPassword, new_password) {
    const url = this._getFullURL("/change-password");
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: {
          old: old_password,
          confirm: confirmPassword,
          password: new_password,
        },
        method: "POST",
      })
    );
  }

  forgotPassword(email) {
    const url = this._getFullURL("/auth/password_reset");
    const payload = {
      email,
    };

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload,
        method: "POST",
      })
    );
  }
  submit_roi(payload) {
    const url = this._getFullURL("/auth/save_sheet");

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload,
        method: "POST",
      })
    );
  }

  resetPassword(token, password) {
    const url = this._getFullURL("/auth/password_reset_confirm");
    const payload = {
      token,
      password,
    };

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        payload,
        method: "POST",
      })
    );
  }

  publicRegister(payload) {
    const url = this._getFullURL("/auth/register-public");

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        publicAuthentication: true,
        payload,
        method: "POST",
      })
    );
  }

  emailActivation(token) {
    const url = this._getFullURL("/auth/register-activation");
    const payload = {
      token,
    };

    return fetch(
      url,
      this._generateRequestBody({
        authentication: false,
        publicAuthentication: true,
        payload,
        method: "POST",
      })
    );
  }
}
